import {BBModel} from "../../bb_model";
import {BaseModel} from "../base";
import {purchase} from "../../services/purchase";

class Purchase_TotalModel extends BaseModel {

    constructor(data) {
        super(data);
        this.promise = this._data.$get('purchase_items');
        this.purchase_items = [];
        this.promise.then((items) => {
                return Array.from(items).map(item =>
                    this.purchase_items.push(new BBModel.PurchaseItem(item)));
            }
        );
        if (this._data.$has('client')) {
            const cprom = data.$get('client');
            cprom.then((client) => {
                    return this.client = new BBModel.Client(client);
                }
            );
        }
        this.created_at = moment.parseZone(this.created_at);
        if (this.time_zone) {
            this.created_at.tz(this.time_zone);
        }
    }


    /**
     * @description
     * Get the icalLink
     *
     * @returns {object} The returned icalLink
     */
    icalLink() {
        return this._data.$href('ical');
    }

    /**
     * @description
     * Get webcalLink
     *
     * @returns {object} The returned webcalLink
     */
    webcalLink() {
        return this._data.$href('ical');
    }

    /**
     * @description
     * Get the gcalLink
     *
     * @returns {object} The returned gcalLink
     */
    gcalLink() {
        return this._data.$href('gcal');
    }

    /**
     * @description
     * Get the id
     *
     * @returns {object} The returned id
     */
    id() {
        return this.get('id');
    }

    static $query(params) {
        return purchase.query((params));
    }

    static $bookingRefQuery(params) {
        return purchase.query((params));
    }
}

export {
    Purchase_TotalModel
}